import { useState, useEffect } from "react"
import { useLocation, useNavigate } from 'react-router-dom';

import CboFamiliar from "./CboFamiliar"
import ConfirmationModal from "./ConfirmModal";
import { formatDate, formatDNI } from "./format";
import Toast from 'react-bootstrap/Toast';
import ToastContainer from 'react-bootstrap/ToastContainer';

const AluFamilia = ({ selectedValue, onChange, disabled }) => {


  var antcodFam, antpar01, antnombre01, antdirec01, anttelef01, antdni01, antfnac01,
    antpar02, antnombre02, antdirec02, anttelef02, antdni02, antfnac02, antpar03, antnombre03, antdirec03, anttelef03, antdni03, antfnac03;

  const [noteditable, setNotEditable] = useState(true)

  const [alumno, setAlumno] = useState("");
  const [codFam, setCodFam] = useState("");
  const [par01, setPar01] = useState(1);
  const [nombre01, setNombre01] = useState("");
  const [direc01, setDirec01] = useState("");
  const [telef01, setTelef01] = useState("");
  const [dni01, setDNI01] = useState("");
  const [dniFormat01, setDNIFormat01] = useState("");
  const [fnac01, setFNac01] = useState("");


  const [par02, setPar02] = useState(2);
  const [nombre02, setNombre02] = useState("");
  const [direc02, setDirec02] = useState("");
  const [telef02, setTelef02] = useState("");
  const [dni02, setDNI02] = useState("");
  const [dniFormat02, setDNIFormat02] = useState("");
  const [fnac02, setFNac02] = useState("");
  const [hermanos, setHermanos] = useState([]);

  const [buscador, setBuscador] = useState(false);
  const [searchFam, setSearchFam] = useState("");
  const [resultados, setResultados] = useState([]);


  const [par03, setPar03] = useState(3);
  const [nombre03, setNombre03] = useState("");
  const [direc03, setDirec03] = useState("");
  const [telef03, setTelef03] = useState("");
  const [dni03, setDNI03] = useState("");
  const [dniFormat03, setDNIFormat03] = useState("");
  const [fnac03, setFNac03] = useState("");




  // toast
  const [showToast, setShowToast] = useState(false);
  const [textoToast, setTextoToast] = useState("");
  const [backgrnd, setBackgrnd] = useState('success');

  // ventana modal de confirmación
  const [showConfirm, setShowConfirm] = useState(false);
  const [messageConfirm, setMessageConfirm] = useState("");

  const handleClose = () => setShowConfirm(false);
  const handleShow = () => setShowConfirm(true);

  const usenav = useNavigate();

  async function handleNew(e) {

    e.preventDefault()
    try {
      setCodFam(""); setPar01(1); setNombre01(""); setDirec01(""); setTelef01(""); setDNI01(""); setFNac01("");
      setPar02(2); setNombre02(""); setDirec02(""); setTelef02(""); setDNI02(""); setFNac02(""); setNombre03("");
      setNotEditable(false); setPar03(3); setDirec03(""); setTelef03(""); setDNI03(""); setFNac03("");
    } catch (error) {
      console.log(error);

    }
  }
  async function handleEdit(e) {
    e.preventDefault()
    try {
      antcodFam = codFam; antpar01 = par01; antnombre01 = nombre01; antdirec01 = direc01; anttelef01 = telef01; antdni01 = dni01; antfnac01 = fnac01;
      antpar02 = par02; antnombre02 = nombre02; antdirec02 = direc02; anttelef02 = telef02; antdni02 = dni02; antfnac02 = fnac02; antpar03 = par03; antnombre03 = nombre03; antdirec03 = direc03; anttelef03 = telef03; antdni03 = dni03; antfnac03 = fnac03;
      setNotEditable(false);

    } catch (error) {
      console.log(error);

    }
  }
  async function handleSave(e) {
    e.preventDefault()
    try {
      setMessageConfirm("¿Guardar los cambios?")
      handleShow();
    } catch (error) {
      console.log(error);

    }
  }

  /* Save */
  async function handleDoSave(e) {
    handleClose();
    // validar ???

    // llamo a la grabación del registro de alumno

    let unFamilia = new Object();
    unFamilia.alumno = alumno;
    unFamilia.codfam = codFam;
    unFamilia.grupo = 1;
    unFamilia.empresa = 1;
    unFamilia.par01 = par01;
    unFamilia.nombre01 = nombre01;
    unFamilia.direc01 = direc01;
    unFamilia.telef01 = telef01;
    unFamilia.dni01 = dni01;
    unFamilia.fnac01 = fnac01;
    unFamilia.par02 = par02;
    unFamilia.nombre02 = nombre02;
    unFamilia.direc02 = direc02;
    unFamilia.telef02 = telef02;
    unFamilia.dni02 = dni02;
    unFamilia.fnac02 = fnac02;
    unFamilia.par03 = par03;
    unFamilia.nombre03 = nombre03;
    unFamilia.direc03 = direc03;
    unFamilia.telef03 = telef03;
    unFamilia.dni03 = dni03;
    unFamilia.fnac03 = fnac03;
    var url;
    var json;
    e.preventDefault()
    try {
      setNotEditable(true);
      json = JSON.stringify(unFamilia);
      console.log(json);
      if (unFamilia.codfam) {
        url = `${process.env.REACT_APP_API_URL}/fam/update`;
      }
      else {
        url = `${process.env.REACT_APP_API_URL}/fam/addnew`;
      }


      var options = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        mode: 'cors',
        credential: 'include',
        body: json,

      };

      fetch(url, options)
        .then(response => response.json())
        .then(data => {

          json = data.data;
          console.log(json);
          // setNombre (json.nombre);
          // setApellido (json.apellido);            
          // setActivo (json.actvo);

          /* toast */
          setTextoToast(json.message);
          setShowToast(true);
          if (json.error == 0) {
            setBackgrnd('succes');
          }
          else {
            setBackgrnd('danger');
          }
        })
    } catch (error) {

      console.log(error);
    }

  }

  async function handleCancel(e) {
    e.preventDefault()
    try {
      //antcodFam = codFam;
      //  antpar01 = par01;
      //  antnombre01 = nombre01;
      //  antdirec01 = direc01;
      //  anttelef01 = telef01;
      //  antdni01 = dni01; 
      // antfnac01 = fnac01;
      //antpar02 = par02;
      //  antnombre02 = nombre02;
      //  antdirec02 = direc02;
      //  anttelef02 = telef02;
      //  antdni02 = dni02; 
      // antfnac02 = fnac02; 
      // antpar03 = par03;
      //  antnombre03 = nombre03;
      //  antdirec03 = direc03;
      //  anttelef03 = telef03;
      //  antdni03 = dni03; 
      // antfnac03 = fnac03;

      setCodFam(antcodFam)
      setNombre01(antnombre01)
      setPar01(antpar01)
      setDirec01(antdirec01)
      setTelef01(anttelef01)
      setDNI01(antdni01)
      setFNac01(antfnac01)
      setPar02(antpar02)
      setNombre02(antnombre02)
      setDirec02(antdirec02)
      setTelef02(anttelef02)
      setDNI02(antdni02)
      setFNac02(antfnac02)
      setPar03(antpar03)
      setNombre03(antnombre03)
      setDirec03(antdirec03)
      setTelef03(anttelef03)
      setDNI03(antdni03)
      setFNac03(antfnac03)





      setNotEditable(true);
    } catch (error) {
      console.log(error);

    }
  }

  const handleFam01Change = (event) => {
    setPar01(event.target.value);
  };

  const handleFam02Change = (event) => {
    setPar02(event.target.value);
  };

  const handleFam03Change = (event) => {
    setPar03(event.target.value);
  };

  async function handleSearch(e) {
    e.preventDefault()
    try {
      setBuscador(true);
    } catch (error) {
      console.log(error);

    }
  }


  async function handleKeyDown(ev) {
    if (ev.key === 'Enter') {
      handleSearchFam();
    }

  }
  // asignar la familia a un alumno
  async function handleSelecFam(vfam, ev) {
    ev.preventDefault()
    try {

      // asignar familia a alumno


      let unDato = new Object();
      unDato.alumno = alumno;
      unDato.familia = vfam;


      var url;
      var json;

      try {
        setNotEditable(true);
        json = JSON.stringify(unDato);
        console.log(json);
        url = `${process.env.REACT_APP_API_URL}/alu/updfam`;

        var options = {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          mode: 'cors',
          credential: 'include',
          body: json,

        };

        fetch(url, options)
          .then(response => response.json())
          .then(data => {

            json = data.data;
            console.log("resultado asignación familia ", json);
            setCodFam(vfam);
            setResultados([]);
            setBuscador(false);


            /* toast */
            setTextoToast("Familia asignada");
            setShowToast(true);

          });

      } catch (error) {
        console.log(error);

      }
    }  // main try
    catch (error) {
      console.log(error);

    }
  }


  function handleGoAlumno(id, event) {
    console.log("hermano Alumno", id, "--", event.target);


    var jstring;
    var url;

    jstring = '{"id" : "' + id + '" }';
    url = `${process.env.REACT_APP_API_URL}/alu/getone`;

    /* fetch de búsqueda */
    var options = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      mode: 'cors',
      credential: 'include',
      body: jstring,
      //JSON.stringify({"code" : 4, "activo" : true}),

    };

    fetch(url, options)
      .then(response => response.json())
      .then(data => {
        console.log("búsqueda", data.data);
        //usenav('/resultados', { state: { searchdata: data.data } } );
        usenav('/alumnos', { state: { unalumno: data.data } });
        // refresca la pantalla    
        usenav(0);
        /*  if ( data.lista.length)
          {

            
            setListSearch(data.lista);

          }          
            */
      })





    //  usenav('/alumnos');
  }

  async function handleSearchFam() {
    console.log("en el handle");

    var jstring;
    var url;
    jstring = '{"search" : "' + searchFam + '"}';

    url = `${process.env.REACT_APP_API_URL}/fam/search`;

    /* fetch de búsqueda */
    var options = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      mode: 'cors',
      credential: 'include',
      body: jstring,
      //JSON.stringify({"code" : 4, "activo" : true}),

    };

    fetch(url, options)
      .then(response => response.json())
      .then(data => {
        console.log("búsqueda", data.data);
        setResultados(data.data);
        setSearchFam("");
        /*  if ( data.lista.length)
          {

            
            setListSearch(data.lista);

          }          
            */
      })

    setSearchFam("");


  }


  const location = useLocation();


  useEffect(() => {

    var { unalumno } = location.state || {};
    console.log('Alumno a mostrar-Familia:', unalumno);

    // Buscar los datos de la familia del alumno
    if (unalumno) {

      var json3;
      var jsons3;
      var url3;
      let consulta = new Object();

      consulta.valu = unalumno[0].Alu_IdAlu;
      setAlumno(unalumno[0].Alu_IdAlu);
      console.log("Busq Familia", unalumno[0], unalumno[0].Alu_IdAlu);

      jsons3 = JSON.stringify(consulta);


      var options3 = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'

        },
        mode: 'cors',
        credential: 'include',
        body: jsons3,

      };

      url3 = `${process.env.REACT_APP_API_URL}/fam/getone`;



      fetch(url3, options3)
        .then(response => response.json())
        .then(data => {

          json3 = data.data;
          //  setSecciones(json3);
          console.log("Familiares", json3);
          if (json3.length) {
            setCodFam(json3[0].Fam_IdFam);
            setPar01(json3[0].Fam_Par01);
            setNombre01(json3[0].Fam_Nombre01);
            setDirec01(json3[0].Fam_Direc01);
            setTelef01(json3[0].Fam_Telef01);
            setDNI01(json3[0].Fam_DNI01);
            setDNIFormat01(formatDNI(json3[0].Fam_DNI01));
            setFNac01(json3[0].Fam_FNac01.substring(0, 10));

            setPar02(json3[0].Fam_Par02);
            setNombre02(json3[0].Fam_Nombre02);
            setDirec02(json3[0].Fam_Direc02);
            setTelef02(json3[0].Fam_Telef02);
            setDNI02(json3[0].Fam_DNI02);
            setDNIFormat02(formatDNI(json3[0].Fam_DNI02));
            setFNac02(json3[0].Fam_FNac02.substring(0, 10));

            setPar03(json3[0].Fam_Par03);
            setNombre03(json3[0].Fam_Nombre03);
            setDirec03(json3[0].Fam_Direc03);
            setTelef03(json3[0].Fam_Telef03);
            setDNI03(json3[0].Fam_DNI03);
            setDNIFormat03(formatDNI(json3[0].Fam_DNI03));
            setFNac03((json3[0].Fam_FNac03 || "").substring(0, 10));
          }
          else {

            setBuscador(true);
          }

        }) // then fetch a familiares
        /// buscar los hermanos
        .finally(() => {

          console.log("finally");
          var json4;
          var jsons4;
          var url4;
          let consulta4 = new Object();

          consulta4.familia = unalumno[0].Fam_IdFam;
          consulta4.alumno = unalumno[0].Alu_IdAlu;

          jsons4 = JSON.stringify(consulta4);
          console.log("get brothers, ", jsons4);

          var options4 = {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'

            },
            mode: 'cors',
            credential: 'include',
            body: jsons4,

          };

          url4 = `${process.env.REACT_APP_API_URL}/fam/getbrothers`;



          fetch(url4, options4)
            .then(response => response.json())
            .then(data => {

              json4 = data;
              //  setSecciones(json3);
              console.log("Hermanos", json4.data);
              setHermanos(json4.data);
            })

        })



    }
  }, [codFam]);

  return (
    <div className="col-xs-12 col-lg-12 col-sm-12 col-md-12">
      <form className="border border-info p-3">
        <div className="row">

          <div className="col-lg-offset-0 col-lg-2 col-xs-12 col-sm-6">
            <div className="form-group">
              <label htmlFor="exampleInputEmail1">Parentesco</label>
              <CboFamiliar
                selectedValue={par01}
                onChange={handleFam01Change}
                disabled={noteditable}
              />

            </div>
          </div>
          <div className="col-lg-offset-0 col-lg-4 col-xs-6 col-sm-4">
            <div className="form-group">
              <label htmlFor="exampleInputEmail1">Apellido y Nombre</label>
              <input type="text" className="form-control" id="exampleInputEmail1" placeholder="" onChange={e => { setNombre01(e.target.value) }} value={nombre01} disabled={noteditable} />
            </div>
          </div>

          <div className="col-lg-offset-0 col-lg-4 col-xs-6 col-sm-4">
            <div className="form-group">
              <label htmlFor="exampleInputEmail1">Dirección</label>
              <input type="text" className="form-control" id="exampleInputEmail1" placeholder="" onChange={e => { setDirec01(e.target.value) }} value={direc01} disabled={noteditable} />
            </div>
          </div>

          <div className="col-lg-offset-0 col-lg-2 col-xs-12 col-sm-6">
            <div className="form-group">
              <label htmlFor="exampleInputEmail1">Teléfono</label>
              <input type="text" className="form-control" id="exampleInputEmail1" placeholder="" onChange={e => { setTelef01(e.target.value) }} value={telef01} disabled={noteditable} />
            </div>
          </div>
          <div className="col-lg-offset-0 col-lg-2 col-xs-12 col-sm-6">
            <div className="form-group">
              <label htmlFor="exampleInputEmail1">D.N.I.</label>
              <input type="text" className="form-control" id="exampleInputEmail1" placeholder="" onChange={e => { setDNI01(e.target.value) }} value={noteditable ? dniFormat01 : dni01} disabled={noteditable} />
            </div>
          </div>



          <div className="col-lg-offset-0 col-lg-2 col-xs-12 col-sm-6">
            <div className="form-group">
              <label htmlFor="exampleInputEmail1">F. de Nacimiento</label>
              <input type="date" className="form-control" id="exampleInputEmail1" placeholder="" onChange={e => { setFNac01(e.target.value) }} value={fnac01} disabled={noteditable} />
            </div>
          </div>
        </div>

        {/* ==================   MADRES ====================== */}

        <div className="row">

          <div className="col-lg-offset-0 col-lg-2 col-xs-12 col-sm-6">
            <div className="form-group">
              <label htmlFor="exampleInputEmail1">Parentesco</label>
              <CboFamiliar
                selectedValue={par02}
                onChange={handleFam02Change}
                disabled={noteditable}
              />

            </div>
          </div>
          <div className="col-lg-offset-0 col-lg-4 col-xs-6 col-sm-4">
            <div className="form-group">
              <label htmlFor="exampleInputEmail1">Apellido y Nombre</label>
              <input type="text" className="form-control" id="exampleInputEmail1" placeholder="" onChange={e => { setNombre02(e.target.value) }} value={nombre02} disabled={noteditable} />
            </div>
          </div>

          <div className="col-lg-offset-0 col-lg-4 col-xs-6 col-sm-4">
            <div className="form-group">
              <label htmlFor="exampleInputEmail1">Dirección</label>
              <input type="text" className="form-control" id="exampleInputEmail1" placeholder="" onChange={e => { setDirec02(e.target.value) }} value={direc02} disabled={noteditable} />
            </div>
          </div>

          <div className="col-lg-offset-0 col-lg-2 col-xs-12 col-sm-6">
            <div className="form-group">
              <label htmlFor="exampleInputEmail1">Teléfono</label>
              <input type="text" className="form-control" id="exampleInputEmail1" placeholder="" onChange={e => { setTelef02(e.target.value) }} value={telef02} disabled={noteditable} />
            </div>
          </div>
          <div className="col-lg-offset-0 col-lg-2 col-xs-12 col-sm-6">
            <div className="form-group">
              <label htmlFor="exampleInputEmail1">D.N.I.</label>
              <input type="text" className="form-control" id="exampleInputEmail1" placeholder="" onChange={e => { setDNI02(e.target.value) }} value={noteditable ? dniFormat02 : dni02} disabled={noteditable} />
            </div>
          </div>



          <div className="col-lg-offset-0 col-lg-2 col-xs-12 col-sm-6">
            <div className="form-group">
              <label htmlFor="exampleInputEmail1">Fecha de Nacimiento</label>
              <input type="date" className="form-control" id="exampleInputEmail1" placeholder="" onChange={e => { setFNac02(e.target.value) }} value={fnac02} disabled={noteditable} />
            </div>
          </div>
        </div>



        <div className="row">

          <div className="col-lg-offset-0 col-lg-2 col-xs-12 col-sm-6">
            <div className="form-group">
              <label htmlFor="exampleInputEmail1">Parentesco</label>
              <CboFamiliar
                selectedValue={par03}
                onChange={handleFam03Change}
                disabled={noteditable}
              />

            </div>
          </div>
          <div className="col-lg-offset-0 col-lg-4 col-xs-6 col-sm-4">
            <div className="form-group">
              <label htmlFor="exampleInputEmail1">Apellido y Nombre</label>
              <input type="text" className="form-control" id="exampleInputEmail1" placeholder="" onChange={e => { setNombre03(e.target.value) }} value={nombre03} disabled={noteditable} />
            </div>
          </div>

          <div className="col-lg-offset-0 col-lg-4 col-xs-6 col-sm-4">
            <div className="form-group">
              <label htmlFor="exampleInputEmail1">Dirección</label>
              <input type="text" className="form-control" id="exampleInputEmail1" placeholder="" onChange={e => { setDirec03(e.target.value) }} value={direc03} disabled={noteditable} />
            </div>
          </div>

          <div className="col-lg-offset-0 col-lg-2 col-xs-12 col-sm-6">
            <div className="form-group">
              <label htmlFor="exampleInputEmail1">Teléfono</label>
              <input type="text" className="form-control" id="exampleInputEmail1" placeholder="" onChange={e => { setTelef03(e.target.value) }} value={telef03} disabled={noteditable} />
            </div>
          </div>
          <div className="col-lg-offset-0 col-lg-2 col-xs-12 col-sm-6">
            <div className="form-group">
              <label htmlFor="exampleInputEmail1">D.N.I.</label>
              <input type="text" className="form-control" id="exampleInputEmail1" placeholder="" onChange={e => { setDNI03(e.target.value) }} value={noteditable ? dniFormat03 : dni03} disabled={noteditable} />
            </div>
          </div>



          <div className="col-lg-offset-0 col-lg-2 col-xs-12 col-sm-6">
            <div className="form-group">
              <label htmlFor="exampleInputEmail1">Fecha de Nacimiento</label>
              <input type="date" className="form-control" id="exampleInputEmail1" placeholder="" onChange={e => { setFNac03(e.target.value) }} value={fnac03} disabled={noteditable} />
            </div>
          </div>
        </div>








        <div className="row mb-1 border-primary p-2">

          {!codFam ?

            <div className="col  col-1 text-center border-info p-2 m-2">
              <button type="button" className="btn btn-info " id="clear" onClick={handleNew} disabled={!noteditable} >Nuevo</button>
            </div> : ""
          }

          <div className="col  col-1 text-center border-info p-2 m-2">
            <button type="button" className="btn btn-info" id="edit" onClick={handleEdit} disabled={(!codFam) && (!noteditable)}>Editar</button>
          </div>


          <div className="col  col-1 text-center border-info p-2 m-2">
            <button type="button" className="btn btn-info" id="grabar" onClick={handleSave} disabled={noteditable}>Guardar</button>
          </div>
          <div className="col  col-1 text-center border-info p-2 m-2">
            <button type="button" className="btn btn-info" id="cancelar" onClick={handleCancel} disabled={noteditable}>Cancelar</button>
          </div>

          <div className="col  col-2 text-center border-info p-2 m-2">
            <button type="button" className="btn btn-info" id="asignar" onClick={handleSearch} disabled={!noteditable} >Asignar Flia.</button>
          </div>


        </div>

        {buscador ?

          <div className="row mb-1 border-primary p-2">
            <div className="col-lg-offset-0 col-lg-4 col-xs-6 col-sm-4">
              <div className="form-group">
                <label htmlFor="exampleInputEmail1">Buscar familia</label>
                <input type="text" id="searchval" size="50" name="searchfam" onKeyDown={handleKeyDown} onChange={e => { setSearchFam(e.target.value) }} value={searchFam} />
              </div>
            </div>
          </div>







          : ""
        }

        <div className="text-justify col-lg-2 col-sm-2 col-md-2">
          <h4>Hermanos</h4>
        </div>
        <table className={(hermanos) ? "table table-striped table-info table-hover m-3" : "table table-striped table-primary table-hover m-3 d-none"}>

          <thead>
            <tr className="row" >
              <th className="col-3" >Apellido y Nombre</th>
              <th className="col-1" >Sección</th>
              <th className="col-1" >Curso</th>
              <th className="col-1" >División</th>


            </tr>
          </thead>
          <tbody>

            {


              hermanos.map((unolista, index) => (

                <tr key={index + '_row'} className="row">

                  <td key={index + '_nombre'} className="col-3" onClick={(event) => handleGoAlumno(unolista.Alu_IdAlu, event)}>
                    {unolista.Alu_Apellido + ', ' + unolista.Alu_Nombre}
                  </td>
                  <td key={index + '_seccion'} className="col-1" onClick={(event) => handleGoAlumno(unolista.Alu_IdAlu, event)}>
                    {unolista.Sec_Nombre}
                  </td>
                  <td key={index + '_curso'} className="col-1" onClick={(event) => handleGoAlumno(unolista.Alu_IdAlu, event)}>
                    {unolista.Cur_Nombre}
                  </td>
                  <td key={index + '_divis'} className="col-1" onClick={(event) => handleGoAlumno(unolista.Alu_IdAlu, event)}>
                    {unolista.Div_Nombre}
                  </td>

                </tr>
              )
              )

            }
          </tbody>
        </table>






        <table className="table table-striped table-info table-hover m-3">

          <tbody>
            {


              resultados.map((unolista, index) => (
                <tr key={index + '_row'} className="row"  >
                  <td key={index + '_fam01'} className="col-3" >
                    {unolista.Fam_Nombre01}
                  </td>
                  <td key={index + '_fam02'} className="col-3" >
                    {unolista.Fam_Nombre02}
                  </td>
                  <td key={index + '_fam03'} className="col-3" >
                    {unolista.Fam_Nombre03}
                  </td>
                  <td key={index + '_selec'} className="col-2" >
                    <button type="button" className="btn btn-info" onClick={(event) => handleSelecFam(unolista.Fam_IdFam, event)} >Seleccionar</button>
                  </td>
                </tr>
              )
              )
            }

          </tbody>
        </table>


      </form>

     <ToastContainer position="top-end"  className="p-3" style={{ position: 'fixed', top: '120px',  right: '20px', zIndex: 9999}}>
         
        <Toast onClose={() => setShowToast(false)} show={showToast} delay={5000} bg={backgrnd} autohide>

          <Toast.Body>{textoToast}</Toast.Body>
        </Toast>
       
      </ToastContainer>

      <ConfirmationModal
        show={showConfirm}
        handleClose={handleClose}
        handleConfirm={handleDoSave}
        message={messageConfirm}
      />


    </div>
  );
};

export default AluFamilia;